import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  IconButton,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import CustomTable from "../../components/library/CustomTable/Index";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomSearchBar from "../../components/library/CustomSearchBar";
import CustomModel from "../../components/library/CustomModel";
import EditIcon from "@mui/icons-material/Edit";
import CutomConfirmationModel from "../../components/library/CutomConfirmationModel";
import { getPoolDetails, addPool, deletePool, activePool } from "./api";
import Loader from "../../components/loader";
import { toast } from "react-toastify";

export default function PoolDetails({ userId, userName }) {
  const [rows, setRows] = useState();
  const [isSearch, setIsSearch] = useState(0);
  const [filteredRows, setFilteredRows] = useState("");
  const [activePoolId, setActivePoolId] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState("");
  const [isEditModel, setisEditModel] = useState(false);
  const [onSuccessModelClose, setonSuccessModelClose] = useState(false);
  const [openConfirmationModel, setOpenConfirmationModel] = useState(false);
  const [loading, setloading] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [isDelete, setisDelete] = useState(false);
  const columns = [
    "Pool Name",
    "Latitude",
    "Longitude",
    "Lockbox",
    userId ? " Assign" : "Actions",
  ];

  const loadPools = async () => {
    let activePools = [];
    let response = await getPoolDetails(setloading, userId);

    let assignedData = [];
    let unAssignedData = [];

    response?.data?.forEach((element, index) => {
      element.assigned
        ? assignedData.push(element)
        : unAssignedData.push(element);
    });

    let sortData = [...assignedData, ...unAssignedData];

    let data = sortData?.map((item) => {
      if (item?.assigned) {
        activePools.push(item?.poolId);
      }
      return {
        name: item.poolName,
        latitude: item.lat,
        longitude: item.lon,
        lockbox: item.lockbox,
        actions: !userId ? (
          <Box>
            <Tooltip title="Edit" arrow>
              <IconButton onClick={() => setisEditModel(true)}>
                <EditIcon color="secondary" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Delete" arrow>
              <IconButton onClick={() => setOpenConfirmationModel(true)}>
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        ) : (
          <Box>
            <Tooltip title={item?.assigned ? "Assign" : "Unassign"} arrow>
              <Switch
                checked={item?.assigned}
                onClick={() => setOpenConfirmationModel(true)}
              />
            </Tooltip>
          </Box>
        ),
        id: item?.poolId,
      };
    });

    setRows(data);
    setFilteredRows(data);
    setActivePoolId(activePools);
    setSearchVal("");
  };

  const allFields = [
    {
      fieldName: "poolname",
      fieldLabel: "Pool Name",
      fieldType: "text",
      initialValue: selectedRowData?.name || "",
    },
    {
      fieldName: "lockbox",
      fieldLabel: "Lockbox",
      fieldType: "text",
      initialValue: selectedRowData?.lockbox || "",
    },
    {
      fieldName: "latitude",
      fieldLabel: "Latitude",
      fieldType: "number",
      initialValue: selectedRowData?.latitude || "",
    },
    {
      fieldName: "longitude",
      fieldLabel: "Longitude",
      fieldType: "number",
      initialValue: selectedRowData?.longitude || "",
    },
  ];

  // Add new User Api Calling
  async function addNewPool(addPoolData) {
    let data = {
      poolName: addPoolData?.poolname,
      lat: addPoolData?.latitude,
      lon: addPoolData?.longitude,
      lockbox: addPoolData?.lockbox,
    };

    if (selectedRowData && isEditModel) {
      data.poolId = selectedRowData.id;
    }

    let response = await addPool(setloading, data);
    if (response) {
      setonSuccessModelClose(!onSuccessModelClose);
    }

    toast.success(response?.message);
    await loadPools();
  }

  const deleteData = async () => {
    let response = await deletePool(setloading, selectedRowData?.id);
    toast.success(response?.message || "Pool deleted successfully!");
    await loadPools();
  };

  // Active pools location for users
  const ActivePoolByUser = async () => {
    let poolIdData = activePoolId;
    if (poolIdData.includes(selectedRowData?.id)) {
      poolIdData = poolIdData.filter((data) => {
        return data !== selectedRowData?.id;
      });
    } else {
      poolIdData.push(selectedRowData?.id);
    }

    let data = {
      userId: userId,
      locations: poolIdData,
    };

    let response = await activePool(setloading, data);
    toast.success(response?.message || "Pool activated successfully!");
    await loadPools();
  };

  // delete confirmation
  useEffect(() => {
    if (isDelete) {
      setOpenConfirmationModel(false);
      setisDelete(false);
      if (selectedRowData?.id) {
        try {
          {
            userId ? ActivePoolByUser() : deleteData();
          }
        } catch (error) {
          toast.error("Something went wrong!");
        }
      }
    }
  }, [isDelete]);

  useEffect(() => {
    loadPools();
  }, []);

  useEffect(() => {
    let messege = "";
    if (selectedRowData) {
      if (activePoolId.includes(selectedRowData?.id)) {
        messege = "Are you sure you want to unassign this pool to";
      } else {
        messege = "Are you sure you want to assign this pool to";
      }
    }
  }, [selectedRowData]);

  return (
    <div>
      {loading && <Loader />}

      <CutomConfirmationModel
        open={openConfirmationModel}
        setOpen={setOpenConfirmationModel}
        title={userId ? "Location Assignment" : "Delete Confirmation"}
        messege={
          <>
            {userId ? (
              <Typography>
                Are you sure you want to{" "}
                {activePoolId.includes(selectedRowData?.id)
                  ? "unassign"
                  : "assign"}{" "}
                {selectedRowData?.name} pool to
                <span style={{ color: "red" }}> {userName} </span> ?
              </Typography>
            ) : (
              <Typography>
                Are you sure you want to delete
                <span style={{ color: "red" }}> {selectedRowData?.name} </span>
                pool ?
              </Typography>
            )}
          </>
        }
        setisAction={setisDelete}
      />

      <Grid container gap={2} justifyContent={"space-between"}>
        <Grid item md={3} lg={2} xl={1.5} xs={12} sm={12}>
          {!userId && (
            <CustomModel
              title={isEditModel ? "Edit Pool" : "Add New Pool"}
              buttonTitle={isEditModel ? "Edit Pool" : "Add Pool"}
              allFields={allFields}
              isEditModel={isEditModel}
              setisEditModel={setisEditModel}
              onSuccessModelClose={onSuccessModelClose}
              formMethod={addNewPool}
              setSelectedRowData={setSelectedRowData}
            />
          )}
        </Grid>

        <Grid item md={3} lg={userId ? 5 : 2} xs={12} sm={12}>
          <CustomSearchBar
            rows={rows}
            setFilteredRows={setFilteredRows}
            setIsSearch={setIsSearch}
            searchVal={searchVal}
            setSearchVal={setSearchVal}
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 2 }}>
        <CustomTable
          setSelectedRowData={setSelectedRowData}
          rows={filteredRows}
          columns={columns}
          isSearch={isSearch}
        />
      </Box>
    </div>
  );
}
